export const removePageScroll = {
  data() {
    return {
      bodyTag: document.querySelector('body'),
    };
  },

  methods: {
    preventDefault(e) {
      e.preventDefault();
    },

    disableScroll() {
      this.bodyTag.classList.add('body-hide-overflow');
    },

    enableScroll() {
      this.bodyTag.classList.remove('body-hide-overflow');
    },

    removePageScroll(value) {
      value ? this.disableScroll() : this.enableScroll();
    },
  },
};
